import React from 'react';
import PropTypes from 'prop-types';
import { FlightTicketPropType } from '../../../../PropTypes';
import { Form, Col, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';
import Select from 'react-select';
import { DATETIME_FORMAT_ISO, DATE_FORMAT_WEB } from 'Constants/DateFormatConstants';
import { DateTimeFormater } from 'Helpers/DateTimeHelper';

const parseBooleanOrNull = (value) => {
  if (value === 'true' || value === true) return true;
  if (value === 'false' || value === false) return false;
  return null;
};

const normalizeAirportArray = (value) => {
  if (Array.isArray(value)) return value;
  if (value) return [value];
  return [];
};

const BookReturnFlightSection = ({
  flyToWorkTicketInfo,
  mappedAirports,
  handleUpdateFlightTicketInfo,
  isArrivalDepartureAirportDisabled,
  darkMode,
  getReactSelectStyles,
}) => (
  <div hidden={!parseBooleanOrNull(flyToWorkTicketInfo.isBookReturnFlight)}>
    <hr />
    <Row>
      <Form.Group as={Col}>
        <Form.Label>(BRF) Return Flight Date</Form.Label>
        <Datetime
          timeFormat={false}
          dateFormat={DATE_FORMAT_WEB}
          closeOnSelect
          utc={true}
          inputProps={{ placeholder: DATE_FORMAT_WEB }}
          value={DateTimeFormater(flyToWorkTicketInfo.brfReturnFlightDate, null, DATE_FORMAT_WEB)}
          onChange={(e) =>
            handleUpdateFlightTicketInfo('brfReturnFlightDate', DateTimeFormater(e, null, DATETIME_FORMAT_ISO))
          }
        />
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>(BRF) Departure Airport</Form.Label>
        <Select
          options={mappedAirports}
          isSearchable
          isClearable
          isMulti
          onChange={(e) => {
            handleUpdateFlightTicketInfo(
              'brfDepartureAirport',
              e.map((x) => x.value)
            );
          }}
          value={mappedAirports.filter((x) =>
            normalizeAirportArray(flyToWorkTicketInfo.brfDepartureAirport).includes(x.value)
          )}
          isDisabled={isArrivalDepartureAirportDisabled()}
          styles={getReactSelectStyles(darkMode)}
        />
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>(BRF) Arrival Airport</Form.Label>
        <Select
          options={mappedAirports}
          isSearchable
          isClearable
          isMulti
          onChange={(e) => {
            handleUpdateFlightTicketInfo(
              'brfArrivalAirport',
              e.map((x) => x.value)
            );
          }}
          value={mappedAirports.filter((x) =>
            normalizeAirportArray(flyToWorkTicketInfo.brfArrivalAirport).includes(x.value)
          )}
          isDisabled={isArrivalDepartureAirportDisabled()}
          styles={getReactSelectStyles(darkMode)}
        />
      </Form.Group>
    </Row>
  </div>
);

BookReturnFlightSection.propTypes = {
  flyToWorkTicketInfo: FlightTicketPropType.isRequired,
  mappedAirports: PropTypes.array.isRequired,
  handleUpdateFlightTicketInfo: PropTypes.func.isRequired,
  isArrivalDepartureAirportDisabled: PropTypes.func.isRequired,
  darkMode: PropTypes.bool.isRequired,
  getReactSelectStyles: PropTypes.func.isRequired,
};

export default React.memo(BookReturnFlightSection);
